module.exports = __webpack_public_path__ + "static/media/Maria_Schiratti_ved_Toniolo.6459c61e.jpg";